"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _feedbackBenefitBanners = require("./feedbackBenefitBanners");
Object.keys(_feedbackBenefitBanners).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _feedbackBenefitBanners[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _feedbackBenefitBanners[key];
    }
  });
});
var _catalogueDynamicUrl = require("./catalogueDynamicUrl");
Object.keys(_catalogueDynamicUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _catalogueDynamicUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _catalogueDynamicUrl[key];
    }
  });
});
var _pdpUrl = require("./pdpUrl");
Object.keys(_pdpUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pdpUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pdpUrl[key];
    }
  });
});
